// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import appInfo from '../../../../configs/app-info';

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Grid, { GridProps } from '@mui/material/Grid';
import { styled, useTheme } from '@mui/material/styles'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import CircularProgress from '@mui/material/CircularProgress'
import FormLabel from '@mui/material/FormLabel'
import {
    CardActions,
    Divider,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    Tooltip,
    Fab,
    FormControlLabel,
    Checkbox,
    OutlinedInput,
    Rating,
    Autocomplete
} from '@mui/material'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'

import { useNavigate, useSearchParams } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'
import moment from 'moment'
// import 'moment/locale/id'

import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';

export default function Add() {
    const [searchParams] = useSearchParams();
    const isMasuk = searchParams.get('is_masuk') || 'default';
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])

    const [valAkun, setValAkun] = useState<any>(null)
    const [listAkun, setListAkun] = useState<any[]>([])

    useEffect(() => {
        getAkun()
        getDoctag()
        if (isMasuk == "1") {
            setValDoctag({
                id: 12511000003,
                name_tag: "KAS MASUK KAS KECIL"
            })
            setValue('sysdoctag_id', 12511000003)
        } else {
            setValDoctag({
                id: 12511000004,
                name_tag: "KAS KELUAR KAS KECIL"
            })
            setValue('sysdoctag_id', 12511000004)
        }
    }, [])

    const getDoctag = () => {
        const url = apiUrl.apiUrl + '/acc/mutasi-kas/get-doctag'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListDoctag(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getAkun = () => {
        const url = apiUrl.apiUrl + '/acc/mutasi-kas/get-akun'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    if (Array.isArray(data)) {
                        data.forEach((item: any) => {
                            if (item && item.id != null && item.nama != null) item.nama = `${item.id} | ${item.nama} | Saldo: ${item.saldo ?? 0}`
                        })
                    }
                    setListAkun(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getAkunByDoctag = (ids: any) => {
        const url = apiUrl.apiUrl + '/acc/mutasi-kas/get-akun-by-doctag/' + ids
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data[0]
                    if (data == undefined) {
                        setValAkun(null)
                    } else {
                        listAkun.forEach(element => {
                            if (element.id == data.hasil) {
                                setValue('accakun_id', element.id)
                                setValue('jenis_transaksi', element.nama)
                                setValAkun(element)
                            }
                        })
                    }
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const navigate = useNavigate();

    interface FormInputs {
        syscabang_id: any
        sysdoctag_id: any
        accakun_id: any
        sysmatauang_id: any
        jenis_transaksi: any
        keterangan: any
        total_valas: any
        total: any
        tgl: any
        kepada: any
        is_masuk: any
    }

    const defaultValues = {
        syscabang_id: 1,
        tgl: moment().format('YYYY-MM-DD'),
        is_masuk: isMasuk,
        kepada: null
    }

    // ** Hooks
    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const onSubmit = (data: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            html: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/acc/mutasi-kas/add'
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                html: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    const id = response.data.data
                                    navigate('/acc/mutasi-kas-bank/detail/' + id)
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                html: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    const handleChangeDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sysdoctag_id', newValue?.id)
        getAkunByDoctag(newValue?.id)
        setValDoctag(newValue)
    }

    const handleChangeAkun = (event: SyntheticEvent, newValue: any | null) => {
        setValue('accakun_id', newValue?.id)
        setValue('jenis_transaksi', newValue?.nama)
        setValAkun(newValue)
    }

    const renderMaster = () => {
        return (
            <CardContent>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                            Document
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='sysdoctag_id'
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { value, onChange } }) => (
                                    <Autocomplete
                                        value={valDoctag}
                                        options={listDoctag}
                                        id='sysdoctag_id'
                                        readOnly
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        onChange={handleChangeDoctag}
                                        renderOption={(props, option) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.name_tag}
                                                </li>
                                            )
                                        }}
                                        getOptionLabel={option => option.name_tag}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                label='Document'
                                                error={Boolean(errors.sysdoctag_id)}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                )}
                            />
                            {errors.sysdoctag_id && (
                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    {/* <Grid item xs={12} sm={6}></Grid> */}
                    <Grid item xs={12} sm={6}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                            Akun
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='accakun_id'
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { value, onChange } }) => (
                                    <Autocomplete
                                        value={valAkun}
                                        options={listAkun}
                                        id='accakun_id'
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        onChange={handleChangeAkun}
                                        renderOption={(props, option) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                    {option.nama}
                                                </li>
                                            )
                                        }}
                                        getOptionLabel={option => option.nama}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                label='Akun'
                                                error={Boolean(errors.accakun_id)}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                )}
                            />
                            {errors.accakun_id && (
                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                            Tanggal Transaksi
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='tgl'
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { value, onChange } }) => (
                                    <TextField
                                        label='Tanggal Transaksi'
                                        type='date'
                                        error={Boolean(errors.tgl)}
                                        onChange={onChange}
                                        value={value}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                )}
                            />
                            {errors.tgl && (
                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                            Tujuan
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='kepada'
                                control={control}
                                rules={{ required: false }}
                                render={({ field: { value, onChange } }) => {
                                    return (
                                        <TextField
                                            label='Tujuan'
                                            error={Boolean(errors.kepada)}
                                            onChange={onChange}
                                            value={value}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )
                                }}
                            />
                            {errors.kepada && (
                                <FormHelperText sx={{ mt: 0, color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6} hidden>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                            Total Valas
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='total_valas'
                                control={control}
                                rules={{ required: false }}
                                render={({ field: { value, onChange } }) => {
                                    return (
                                        <TextField
                                            fullWidth
                                            label='Total Valas'
                                            name='total_valas'
                                            value={
                                                value !== undefined && value !== null && value !== ''
                                                    ? (() => {
                                                        // Format value for display: replace dot with comma, add thousand separator
                                                        const str = String(value).replace('.', ',')
                                                        const [integer, decimal] = str.split(',')
                                                        let formatted = integer ? Number(integer).toLocaleString('id-ID') : ''
                                                        if (decimal !== undefined) {
                                                            formatted += ',' + decimal
                                                        }
                                                        return formatted
                                                    })()
                                                    : ''
                                            }
                                            onChange={e => {
                                                let input = e.target.value

                                                // Remove all except digits and comma
                                                input = input.replace(/[^0-9,]/g, '')

                                                // Split integer and decimal part
                                                const [intPart, decimalPart] = input.split(',')

                                                // Format integer part with thousand separator
                                                let formatted = ''
                                                if (intPart) {
                                                    const parsed = parseInt(intPart, 10)
                                                    formatted = isNaN(parsed) ? '' : parsed.toLocaleString('id-ID')
                                                }
                                                if (decimalPart !== undefined) {
                                                    formatted += ',' + decimalPart
                                                }

                                                // Raw value for backend: replace comma with dot
                                                const rawValue = decimalPart !== undefined ? `${intPart}.${decimalPart}` : intPart

                                                setValue('total_valas', rawValue)
                                                setValue('total', rawValue)
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{ inputMode: 'decimal' }}
                                        />
                                    )
                                }}
                            />
                            {errors.total_valas && (
                                <FormHelperText sx={{ mt: 0, color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                            Keterangan
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='keterangan'
                                control={control}
                                rules={{ required: false }}
                                render={({ field: { value, onChange } }) => {
                                    return (
                                        <TextField
                                            label='Keterangan'
                                            rows={2}
                                            multiline
                                            error={Boolean(errors.keterangan)}
                                            onChange={onChange}
                                            value={value}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )
                                }}
                            />
                            {errors.keterangan && (
                                <FormHelperText sx={{ mt: 0, color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                </Grid>
                <Box
                    sx={{
                        pt: 5,
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <Button size='large' type='submit' sx={{ width: 'auto' }} variant='contained'>
                        SIMPAN
                    </Button>
                </Box>
            </CardContent>
        )
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Buat Mutasi Kas Bank
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center', mb: 2 }}>
                        Jenis Mutasi : <b>{isMasuk == '1' ? 'KAS MASUK' : 'KAS KELUAR'}</b>
                    </Typography>
                    <Divider sx={{ m: 0 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>{renderMaster()}</form>
                </div>
            </Grid>
        </Grid>
    )
}
